import React from 'react'
import Widget from '../../elements/Widget'

const importantFolders = [
  {
    name: 'public',
    description:
      'Includes the main html file and all the static assets and content used in the template'
  },
  {
    name: 'src',
    description:
      'Includes all the React components with their styles and data sources'
  },
  {
    name: 'src/scss',
    description:
      'Includes all the <code>.scss</code> files used in the template'
  },
  {
    name: 'src/css',
    description:
      'Includes all the compiled <code>.css</code> files generated by SASS'
  },
  {
    name: 'src/reducers',
    description: 'Redux reducers can be found in this folder'
  },
  {
    name: 'src/actions',
    description: 'Redux actions can be found in this folder'
  },
  {
    name: 'src/json',
    description:
      'Sample json data used in some views and widgets can be found in this folder'
  }
]

const ImportantFolders = () => (
  <Widget title="Folders" description="Important folders in the template">
    <div className="row">
      <div className="col">
        <ol>
          {importantFolders.map((folder, i) => (
            <li key={i}>
              <p>
                <code>{folder.name}</code>
              </p>
              <p dangerouslySetInnerHTML={{__html: folder.description}} />
            </li>
          ))}
        </ol>
      </div>
    </div>
  </Widget>
)
export default ImportantFolders
